import { logoClient } from 'myNet'

import logoDB from 'libs/DB/logoDB'

import { generateFilename } from 'utils'

interface DownloadResult {
  downloadPath: string
  blob?: Blob
  path?: string
  download: () => void
}

interface DownloadOptions {
  headers: {
    crauth: string
  }
}

interface ReqMapItem {
  resolve: (url: string | null) => void
  reject: (e: Error) => void
}

// Size: 기본값: 256 (72 | 256 | 1024) 이외 값은 에러
export function download(
  domain: string,
  size?: number,
  onProgress?: ((event: ProgressEvent<EventTarget>, percent: number) => void) | null,
  onBeforeSend?: ((xhr: XMLHttpRequest) => void) | null,
): Promise<DownloadResult> {
  const params: Record<string, any> = {}

  if (size != null) {
    params.size = size
  }

  const onBeforeSendNew = (xhr: XMLHttpRequest) => {
    xhr.responseType = 'blob'

    if (onBeforeSend != null) {
      onBeforeSend(xhr)
    }
  }

  const options: DownloadOptions = {
    headers: {
      crauth: '3e6cb4dbca5613b723a68d5070cc092da1d839ca5977214cc22a76d2fb2ae224',
    },
  }

  const promise = new Promise<DownloadResult>((resolve, reject) => {
    logoClient
      .xhrGet(`/logo/download/${domain}/`, params, onProgress, onBeforeSendNew, options)
      .then(({ xhr }: { xhr: XMLHttpRequest }) => {
        console.log('xhrGetFile', xhr)

        let blob = xhr.response as Blob

        if (blob.type === 'application/json') {
          console.log(' --- download error : is not image')
          reject(new Error('is not image.'))
          return
        }

        let downloadBlob = blob
        const mimetype = xhr.getResponseHeader('file-content-type')
        const dispositionValue = xhr.getResponseHeader('content-disposition')

        let fileName: string | null = null
        if (dispositionValue != null) {
          const pairs = dispositionValue.split(';')

          const map: Record<string, string | null> = {}
          pairs.forEach((text) => {
            const subPairs = text.trim().split('=')
            if (subPairs.length > 1) {
              map[subPairs[0].trim()] = subPairs[1].trim().replace(/["']/g, '')
            } else {
              map[subPairs[0].trim()] = null
            }
          })

          fileName = map.filename || null
        }

        if (mimetype != null) {
          downloadBlob = new Blob([blob], { type: mimetype })
        }

        const ret: DownloadResult = {
          downloadPath: window.URL.createObjectURL(downloadBlob),
          download: function () {
            console.log(' - downloadImg : ', fileName, this.downloadPath)
            const link = document.createElement('a')
            link.href = this.downloadPath
            link.download = generateFilename(fileName || '')
            link.click()
            link.remove() // IE 미지원
          },
        }

        if (fileName != null || mimetype != null) {
          if (blob.type === 'text/xml' && fileName != null) {
            const lcFileName = fileName.toLowerCase()
            if (lcFileName.endsWith('.svg') === true) {
              blob = new Blob([blob], { type: 'image/svg+xml' })
              // heic 지원 안함.
              // } else if (
              //   lcFileName.endsWith('.heic') === true ||
              //   lcFileName.endsWith('.heif') === true
              // ) {
              //   const tmpFile = new File([blob], fileName, { type: mimetype || 'image/heic' })
              //   // createObjectURL에는 blob, file 모두 사용가능하므로, file을 blob 대신 전달.
              //   if (onProgress != null) {
              //     onProgress(null, null)
              //   }
              //   convertHEIC(tmpFile, 'image/jpeg', 0.8).then((imgBlob) => {
              //     console.log(imgBlob)
              //     if (onProgress != null) {
              //       onProgress(null, null)
              //     }
              //     ret.blob = imgBlob
              //     ret.path = window.URL.createObjectURL(imgBlob)
              //     resolve(ret)
              //   })

              //   return
            } else if (mimetype != null) {
              blob = new Blob([blob], { type: mimetype })
            }
          } else if (mimetype != null) {
            blob = new Blob([blob], { type: mimetype })
          }

          ret.blob = blob
          ret.path = window.URL.createObjectURL(blob)
        }

        resolve(ret)
      })
      .catch((err: Error) => {
        console.log(' --- download error ', err)
        // @todo - error 처리. - 404 file not found.
        reject(err)
      })
  })

  return promise
}

const reqMap: Record<string, ReqMapItem[]> = {}

function getThumbIcon0(
  domain: string,
  size: number | undefined,
  domainKey: string,
): Promise<string | null> {
  const promise = new Promise<string | null>((resolve) => {
    logoDB.getDB().then(() => {
      const downloadAndCache = (): void => {
        setTimeout(() => {
          download(domain, size)
            .then(({ blob }) => {
              logoDB.putData(domainKey, blob).then((imgData) => {
                resolve(imgData.url)
              })
            })
            .catch(() => {
              // 1시간 동안 다시 시도하지 않음.
              logoDB.putData(domainKey, null, 60 * 60 * 1000).then((imgData) => {
                resolve(imgData.url)
              })
            })
        }, 10)
      }

      logoDB
        .getData(domainKey)
        .then((data) => {
          // console.log(' --- image data --- ', data)
          if (data != null) {
            resolve(data.url)
          } else {
            downloadAndCache()
          }
        })
        .catch((e) => {
          console.log(' --- thumb load ', e)
          downloadAndCache()
        })
    })
  })

  return promise
}

export function getThumbIcon(domain: string, size?: number): Promise<string | null> {
  const domainKey = size != null ? `${domain}_${size}` : domain

  if (reqMap[domainKey] == null) {
    reqMap[domainKey] = []
  }

  if (reqMap[domainKey].length === 0) {
    getThumbIcon0(domain, size, domainKey)
      .then((url) => {
        reqMap[domainKey].forEach(({ resolve }) => {
          resolve(url)
        })

        reqMap[domainKey] = []
      })
      .catch((e) => {
        reqMap[domainKey].forEach(({ reject }) => {
          reject(e)
        })

        reqMap[domainKey] = []
      })
  }

  const retPromise = new Promise<string | null>((resolve, reject) => {
    reqMap[domainKey].push({
      resolve,
      reject,
    })
  })

  return retPromise
}

export async function getAsyncThumbIcon(email: string, size?: number): Promise<string | null> {
  return new Promise((resolve) => {
    try {
      // emailAddress is not imported, so we need to handle this
      // Assuming email parsing logic here
      const emailParts = email.split('@')
      if (emailParts.length === 2) {
        const host = emailParts[1]
        getThumbIcon(host, size).then((ret) => {
          resolve(ret)
        })
      } else {
        resolve(null)
      }
    } catch {
      resolve(null)
    }
  })
}

const apis = {
  download,
  getThumbIcon,
}

export default apis
